import script from "./WhitelabelCustomDomain.vue?vue&type=script&setup=true&lang=js"
export * from "./WhitelabelCustomDomain.vue?vue&type=script&setup=true&lang=js"

import "./WhitelabelCustomDomain.vue?vue&type=style&index=0&id=17dcc2b8&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17dcc2b8"]])

export default __exports__